import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { I18nextProvider } from 'react-i18next';
import { WidgetView, WidgetViewProps } from 'src/models/WidgetView';
import './attendanceStyles.css';
import { getDayStartDateTimeInISOFormat } from 'src/utils/DateTimeUtils';
import { getTAAComponentConfig } from 'src/components/Widgets/WidgetUtils';
import {
  AttendanceListComponent,
  AttendanceFeatures,
  TaaConfigsContextProvider,
} from '@amzn/atoz-dashboard-taa-components';
import { setupI18nextLanguage } from '@amzn/atoz-dashboard-taa-components/dist/i18n';
import { getAttendanceFeatures } from 'src/features';

export interface AttendanceEventHistoryProps extends WidgetViewProps {}
const AttendanceEventHistory: WidgetView = ({ employeeInfo, contactId }: AttendanceEventHistoryProps) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const features = window['AtoZContext']?.employee?.enabledFeatures || [];
  const attendanceFeatures: AttendanceFeatures = getAttendanceFeatures(features);
  const queryParams = {
    contactId: contactId,
  };

  return (
    <QueryClientProvider client={new QueryClient()}>
      <I18nextProvider i18n={setupI18nextLanguage('en-US')}>
        <TaaConfigsContextProvider taaConfigs={getTAAComponentConfig(employeeInfo)}>
          <AttendanceListComponent
            employeeId={employeeInfo.employeeId}
            dateTime={getDayStartDateTimeInISOFormat()}
            timezone={employeeInfo.timeZoneId}
            attendanceFeatures={attendanceFeatures}
            queryParams={queryParams}
          />
        </TaaConfigsContextProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
};

export default AttendanceEventHistory;
